import { request as umiRequest } from '@umijs/max';

// 普通接口请求
export const request = <T = any>(url: string, options?: any) => {
    return umiRequest<ApiDataType<T>>(url, options)
        .then((res) => {
            return res.data !== undefined && res.data !== null
                ? (res.data as T)
                : ([] as T);
        })
        .catch(() => {
            return undefined;
        });
};

// 普通 get 请求
export const getRequest = <T = any>(
    url: string,
    params?: any,
    options?: any,
) => {
    return request<T>(url, {
        method: 'GET',
        params,
        ...options,
    });
};

// 普通 post 请求
export const postRequest = <T = any>(
    url: string,
    data?: any,
    options?: any,
) => {
    return request<T>(url, {
        method: 'POST',
        data,
        ...options,
    });
};

// 分页接口请求
export const tableRequest = <T = any>(url: string, options: any) => {
    return umiRequest<PaginationResult<T>>(url, options)
        .then((res) => {
            return res.data as PaginationResult<T>;
        })
        .catch(() => {
            return undefined;
        });
};

// 分页 get 请求
export const getTableRequest = <T = any>(
    url: string,
    params?: any,
    options?: any,
) => {
    return tableRequest<T>(url, {
        method: 'GET',
        params,
        ...options,
    });
};

// 分页 post 请求
export const postTableRequest = <T = any>(
    url: string,
    data?: any,
    options?: any,
) => {
    return tableRequest<T>(url, {
        method: 'POST',
        data,
        ...options,
    });
};
